(() => {
  const OFFSET = 110;

  const root = document.querySelector('[data-article-content]');
  if (!root) return;

  const ps = root.querySelectorAll('p');
  const anchorP = ps[1] || ps[0];
  if (!anchorP) return;

  const toc = document.createElement('div');
  toc.className = 'hz-toc';
  toc.setAttribute('data-toc', '');
  toc.innerHTML = `
    <strong class="hz-toc__title">Table of Contents</strong>
    <ul class="hz-toc__list" data-toc-list></ul>
  `;
  anchorP.insertAdjacentElement('afterend', toc);

  const list = toc.querySelector('[data-toc-list]');
  const headings = root.querySelectorAll('h2, h3');

  // если заголовков мало — скрываем
  if (headings.length < 2) {
    toc.style.display = 'none';
    return;
  }

  const slugify = (t) =>
    t.toLowerCase().trim()
      .replace(/&amp;|&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  headings.forEach((h, idx) => {
    const tag = h.tagName.toLowerCase();
    const text = (h.textContent || '').trim();
    if (!text) return;

    if (!h.id) {
      const base = slugify(text) || `sec-${idx + 1}`;
      let id = base, n = 2;
      while (document.getElementById(id)) id = `${base}-${n++}`;
      h.id = id;
    }

    h.style.scrollMarginTop = `${OFFSET}px`;

    const li = document.createElement('li');
    if (tag === 'h3') li.className = 'hz-toc__item--h3';

    const a = document.createElement('a');
    a.href = `#${h.id}`;
    a.textContent = text;
    a.className = tag === 'h3' ? 'hz-toc__link--h3' : 'hz-toc__link--h2';

    li.appendChild(a);
    list.appendChild(li);
  });

  toc.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const id = link.getAttribute('href').slice(1);
    const target = document.getElementById(id);
    if (!target) return;

    e.preventDefault();
    const y = target.getBoundingClientRect().top + window.pageYOffset - OFFSET;
    window.scrollTo({ top: y, behavior: 'smooth' });
    history.replaceState(null, '', `#${id}`);
  });
})();